import { render, staticRenderFns } from "./InboxDetailInfo.vue?vue&type=template&id=142aeaa2&scoped=true&"
import script from "./InboxDetailInfo.vue?vue&type=script&lang=js&"
export * from "./InboxDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./InboxDetailInfo.vue?vue&type=style&index=0&id=142aeaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142aeaa2",
  null
  
)

export default component.exports